import React from 'react';
import PropTypes from 'prop-types';
import ResponsiveImage from 'components/ResponsiveImage';
import cn from 'classnames';
import Icon from 'components/Icon';
import { breakpoints } from 'js/breakpoints';

import * as css from './StepBlock.scss';

class StepBlock extends React.Component {
  static propTypes = {
    heading: PropTypes.string,
    description: PropTypes.string.isRequired,
    image: PropTypes.exact(ResponsiveImage.propTypes),
  };

  state = {
    closed: true,
  };

  _handleOnClick = () => this.setState({ closed: !this.state.closed });

  render() {
    const { heading, description, image } = this.props;
    const { closed } = this.state;

    return (
      <div
        className={cn(css.block, {
          [css.closed]: closed,
        })}
      >
        {heading && (
          <h4
            className={cn({ [css.active]: !closed })}
            onClick={this._handleOnClick}
          >
            {heading}
            <Icon icon="caret" size={12} />
          </h4>
        )}
        <div className={css.content}>
          {image && (
            <ResponsiveImage
              {...image}
              className={css.image}
              transform="fit"
              sources={[
                {
                  width: 85,
                  media: breakpoints.m,
                },
                {
                  width: 50,
                  media: breakpoints.l,
                },
              ]}
            />
          )}
          <div
            className="wysiwyg"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
      </div>
    );
  }
}

export default StepBlock;
